import { string } from "yup";

function getNavigatorLanguage() {
    if (navigator.languages && navigator.languages.length) {
        return navigator.languages[0];
    }
    else {
        return navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en';
    }
}

export function formatStringOrNoData(value, noDataValue){
    if(value === undefined || value === null)
        return noDataValue; 

    if(value instanceof  string && value.length === 0){
        return noDataValue; 
    }

    return value;
}


function __toLocaleUTCDate(date) {
    const timeDiff = date.getTimezoneOffset() * 60000;
    return new Date(date.valueOf() + timeDiff);
}

export function formatUtcDateWithLocale(date, locale, includeTime) {
    if ((undefined !== date) && (null !== date)) {
        return formatDateWithLocale(__toLocaleUTCDate(date), locale, includeTime);
    }
    return '';
}

export function formatDateWithLocale(date, locale, includeTime) {
    //console.log(`formatDateWithLocale(${date}, ${locale}, ${includeTime})`);
    if ((undefined !== date) && (null !== date)) {
        const day = date.toLocaleDateString(locale, { day: '2-digit' });
        const month = date.toLocaleDateString(locale, { month: 'short' }).replace(/\./g, '');
        const year = date.toLocaleDateString(locale, { year: 'numeric' });
        var retVal = '' + day + '-' + month + '-' + year;
        if (includeTime) {
            const time = date.toLocaleTimeString();
            retVal += '  ' + time;
        }
        return  retVal;
    }
    return '';
}

function __convertToDate(value) {
    if (typeof value === 'number') {
        if (-62135596800000 === value) // Zero / Min DateTime in C#
        {
            return null;
        }
        else {
            return new Date(value);
        }
    }
    else if (typeof value === 'string'){
        return new Date(value);
    }
    else {
        return null;
    }  
}

export function formatDateOrNoData(value, noDataValue, includeTime){
    if(value === noDataValue)
        return value; 
    return formatDate(value, includeTime);
}

export function formatDate(value, includeTime) {
    if (undefined === includeTime) includeTime = false;

    var retVal = '';
    if ((undefined !== value) && (null !== value)) {
        value = __convertToDate(value);
        retVal = (null === value || undefined === value) ? "" : formatDateWithLocale(value, getNavigatorLanguage(), includeTime);
    }

    //console.log(`#1637 formatDate value=${value} includeTime=${includeTime} retVal=${retVal}`);

    return retVal;
}

export function formatUtcDateOrNoData(value, noDataValue, includeTime){
    if(value === noDataValue)
        return value; 
    return formatUtcDate(value, includeTime);
}

export function formatUtcDate(value, includeTime) {
    if (undefined === includeTime) includeTime = false;
 
    var retVal = '';
    if ((undefined !== value) && (null !== value)) {
        value = __convertToDate(value);
        retVal = (null === value || undefined === value) ? "" : formatUtcDateWithLocale(value, getNavigatorLanguage(), includeTime);
    }

    //console.log(`#1637 formatUtcDate value=${value} includeTime=${includeTime} retVal=${retVal}`);

    return retVal;
}

export function formatPercentOrNoData(value, noDataValue){
    if(value === noDataValue){
        return value; 
    }

    return formatPercent(value);
}

export function formatPercentOrNoDataWithDecimalPlaces(value, noDataValue, decimalPlaces){
    if(value === noDataValue){
        return value; 
    }
    else if (isNaN(value)) {
        return noDataValue;
    }
    return formatPercent(value, decimalPlaces);
}

export function formatPercent(value, decimalPlaces) {
    if ((undefined !== value) && (null !== value)) {
        if (undefined === decimalPlaces) decimalPlaces = 0;
        return Number.parseFloat(value).toFixed(decimalPlaces) + '%';
    }
    return '';
}

export function formatSeconds(value, decimalPlaces) {
    if ((undefined !== value) && (null !== value)) {
        if (undefined === decimalPlaces) decimalPlaces = 1;
        return Number.parseFloat(value).toFixed(decimalPlaces) + 's';
    }
    return '';
}

export function formatMinuteAndSeconds(value, decimalPlacesSeconds) {
    if ((undefined !== value) && (null !== value)) {
        if (undefined === decimalPlacesSeconds) decimalPlacesSeconds = 0;
        const num = Number.parseFloat(value);
        const minutes = Math.floor(num / 60);
        const seconds = (num % 60);
    
        // console.log(`num=${num} minutes=${minutes} seconds=${seconds} `);
    
        if (0 !== minutes)
        {
            return minutes.toFixed(0) + 'm ' + seconds.toFixed(decimalPlacesSeconds) + 's';
        }
        else
        {
            return seconds.toFixed(decimalPlacesSeconds) + 's';
        }
    }
    return '';
}

export function formatFractionOrNoData(value, noDataValue){
    if(value === noDataValue){
        return value; 
    }

    return formatFraction(value);
}

export function formatFraction(value) {
    if ((undefined !== value) && (null !== value)) {
        return `${value.numerator} / ${value.denominator}`;
    }
    return '';
}

export function format(value, args) {
    if ((undefined !== args) && (null !== args)){
        for (var k in arguments) {
            value = value.replace(new RegExp("\\{" + k + "\\}", 'g'), args[k]);
        }
    }
  
    return value
}

export function isGuid(stringToTest) {
    if ((undefined !== stringToTest) && (null !== stringToTest)) {
        if (stringToTest[0] === "{") {
            stringToTest = stringToTest.substring(1, stringToTest.length - 1);
        }
        // eslint-disable-next-line
        var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
        return regexGuid.test(stringToTest);
    }
    return '';
}

function maskString(target, mask){
    var maskedString = "";
    for(var i = 0 ; i < target.length ; i++){
        if(i > 0 && i < target.length - 1){
            maskedString += mask;
        }else{
            maskedString += target[i];
        }
    }
    return maskedString;
}

export function AnonymiseString(contentOriginal) {
    var content = contentOriginal;
    if (contentOriginal instanceof Date) {
        content = contentOriginal.getFullYear() + '******';
    }
    else if (typeof content === 'string' || content instanceof String) {
        content = maskString(content, "*");
    }
    else if (typeof content === 'number') {
        content = maskString(content.toString(), "*");
    } 
    return content; 
}

export function removeQuotes(str) {
    if (str.startsWith("\"")) {
        str = str.substring(1);
    }
    if (str.endsWith("\"")) {
        str = str.substring(0, str.length-1);
    }
    return str;
}